import React, { useState, useEffect } from 'react'
import {
    Button, Alert, Flex, Form, Input, Divider,
    Tooltip,
    Radio,
    Card,
    Result,
    Row,
    Col,
    Modal,
    Select,
    Avatar,
    message,
    Badge,
    Tag,
    Image
} from 'antd'
import api from '../../../service/axios'
import { useToasts } from 'react-toast-notifications';
import TelefoneBrasileiroInput from "react-telefone-brasileiro";
import {
    QuestionCircleTwoTone,
    CheckOutlined,
    QuestionCircleOutlined,
    LeftOutlined
} from '@ant-design/icons';
import { userState } from '../../../service/database'
import { useRecoilState } from 'recoil'
import InputMask from 'react-input-mask';
import PIX from '../../../images/pix.png'
import BOLETO from '../../../images/boleto.png'
import CONTRATANTE from '../../../images/contratante.png'
import FIRMA from '../../../images/firma.png'
import SERVICO from '../../../images/servico.png'
import BRASAO from '../../../images/brasao.png'
import INFORMACOES from '../../../images/informacoes.png'
import dayjs from 'dayjs';



export const ARTNova = (props) => {

    const [form] = Form.useForm();
    const ispjObservavel = Form.useWatch('ispj', form)
    const statusObservable = Form.useWatch(['realizado', 'status'], form)
    const razaoObservable = Form.useWatch(['contratante', 'razao'], form)
    const idartscodeObservable = Form.useWatch('idartscode', form)
    const [current, setCurrent] = useState(0)
    const [loading, setLoading] = useState(false)
    const { addToast } = useToasts()
    const [user,] = useRecoilState(userState)
    const [open2, setOpen2] = useState(false)
    const [arts, setArts] = useState([])
    const [previa, setPrevia] = useState(false)

    useEffect(() => {
        //console.log(user)
        getARTs()
    }, [])



    async function saveSolicitacao(solicitacao) {
        try {
            if (previa === true) {
                setLoading(true)
                solicitacao.firmaid = solicitacao.realizado?.firmaid
                await api.post('/api/v1.0/registrado/art', solicitacao,
                    {
                        headers: {
                            'x-access-token': user?.token2
                        }
                    }
                )
                setOpen2(true)
            } else {
                setPrevia(true)
            }
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }


    async function getARTs() {
        try {
            setLoading(true)
            const resp = await api.get('/api/v1.0/registrado/art/preauto',
                {
                    headers: {
                        'x-access-token': user?.token2
                    }
                }
            )

            setArts(resp.data)
            console.log(resp.data)

        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }


    const consultaViaPJ = (_art) => {

        if (form.getFieldValue("viapj") === 1) {
            return <span> serviço realizado por {form.getFieldValue(["realizado", 'razao'])}, registrada no CRQ-X sob nº {form.getFieldValue(["realizado", 'crq'])} </span>
        } else return ''
    }



    const onFinish = values => {
        console.log(values)
        if (values.viapj === 1 && values.realizado.status !== true) {
            addToast("Informe o CNPJ da empresa que realizou o serviço e clique em validar!", { autoDismiss: true, appearance: 'warning' })
            return
        }

        values.firmaid = values.realizado?.firmaid
        values.cep = values.contratante?.cep

        //  console.log(values);
        saveSolicitacao(values)
    };

    const onFailed = values => {
        console.log(values);
        addToast("Verifique se todos os campos foram informados corretamente!", { appearance: 'error', autoDismiss: true })
    };

    //  console.log(user)

    return <Flex vertical gap={5} className='container-rascunho'>

        <Form
            initialValues={props.selected}
            layout='vertical'
            form={form}
            name="control-hooks"
            onFinish={onFinish}
            onFinishFailed={onFailed}>
            <Flex vertical gap={15} style={{ display: previa ? 'none' : 'flex' }}>
                <Form.Item style={{ display: 'none' }} name={'status'} />
                <Form.Item style={{ display: 'none' }} name={'viapj'} />
                <Form.Item style={{ display: 'none' }} name={'firmaid'} />

                <Card variant='borderless' type='inner' size='small' title={<Flex align='center' gap={5}>
                    <Avatar shape='square' src={SERVICO} size={'small'} />
                    SERVIÇO</Flex>}>
                    <Row gutter={8}>
                        <Col span={24} md={24}>
                            <Form.Item
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}
                                name={'idartscode'}
                                label={<Flex gap={5} align='center'>
                                    Qual atividade realizada?
                                    <Tooltip title="Exemplo: Plano de Gerenciamento de Resíduos da Construção Civil – PGRCC"> <QuestionCircleOutlined />
                                    </Tooltip>
                                </Flex>}>
                                <Select
                                    style={{ width: '100%' }}
                                    placeholder={"Selecione uma opção"}
                                    onChange={(e) => {
                                        if (e === 0) {
                                            form.setFieldValue('descricao', '')
                                        } else {
                                            const ar = arts.find(v => v.idartscode === e)
                                            //  console.log('ar', ar)
                                            form.setFieldValue('descricao', ar.descricao)
                                        }
                                        console.log(e)
                                    }}>
                                    {
                                        arts.map((item, index) => {
                                            return <option key={'art'.concat(index)} value={item.idartscode}>{item.descricao}</option>
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24} md={24} style={{ display: idartscodeObservable === 0 ? 'flex' : 'none' }}>
                            <Form.Item
                                style={{ width: '100%' }}
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}
                                name={'descricao'}>
                                <Input.TextArea placeholder='Descreva a atividade realizada' rows={2} size='small' maxLength={1000} style={{ width: '100%' }} showCount />
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>

                {form.getFieldValue("viapj") === 1 && <Card variant='borderless' type='inner' size='small' title={<Flex align='center' gap={5}>
                    <Avatar shape='square' src={FIRMA} size={'small'} />
                    EMPRESA RESPONSÁVEL PELA EXECUÇÃO</Flex>}>
                    <Row gutter={8}>
                        <Col span={24}>

                            <Flex align='center' gap={30}>
                                <Flex align='center'>
                                    <Form.Item name={['realizado', 'status']} style={{ display: 'none' }} />
                                    <Form.Item name={['realizado', 'razao']} style={{ display: 'none' }} />
                                    <Form.Item name={['realizado', 'crq']} style={{ display: 'none' }} />
                                    <Form.Item name={['realizado', 'cnpj']} style={{ display: 'none' }} />
                                    <Form.Item name={['realizado', 'firmaid']} style={{ display: 'none' }} />
                                    <Form.Item
                                        layout='horizontal'
                                        name={['realizado', 'pesquisa']}>
                                        <InputMask
                                            style={{ width: 300 }}
                                            mask={"99.999.999/9999-99"}
                                            placeholder={"99.999.999/9999-90"}
                                        >
                                            {(inputProps) => <Input.Search

                                                enterButton={"Validar"}
                                                loading={loading}
                                                {...inputProps}
                                                onSearch={async () => {
                                                    try {
                                                        setLoading(true)
                                                        const result = await api.post('/api/v1.0/registrado/firma/validar',
                                                            {
                                                                cnpj: form.getFieldValue(['realizado', 'pesquisa'])?.replaceAll('_', '')
                                                            },
                                                            {
                                                                headers: {
                                                                    'x-access-token': user?.token2
                                                                },
                                                            })
                                                        let aux = form.getFieldsValue()
                                                        aux.realizado = result.data
                                                        form.setFieldsValue(aux)
                                                        //console.log(aux)
                                                    } catch (error) {
                                                        let aux = form.getFieldsValue()
                                                        aux.realizado = { status: false, razao: '', crq: '' }
                                                        form.setFieldsValue(aux)

                                                        if (error.message === 'Request failed with status code 404')
                                                            addToast("Nenhum registro localizado para o CNPJ informado, verifique se realmente a empresa possui registro junto ao CRQ10/CE!", { appearance: 'error', autoDismiss: true })
                                                        else
                                                            addToast(error.message, { appearance: 'error', autoDismiss: true })

                                                    }
                                                    setLoading(false)
                                                }} />}
                                        </InputMask>

                                    </Form.Item>
                                </Flex>
                                <Flex align='center' >
                                    {
                                        statusObservable === true && <Card size='small' style={{ backgroundColor: '#fcfcfc', marginTop: 5, width: '100%' }}>
                                            <Flex vertical gap={0}>
                                                <Flex gap={5}><CheckOutlined style={{ color: 'green' }} /> <b>{form.getFieldValue(['realizado', 'razao'])}</b></Flex>
                                                <Flex style={{ marginLeft: 20 }}>Registro: {form.getFieldValue(['realizado', 'crq'])}</Flex>
                                                <Flex style={{ marginLeft: 20 }}>CNPJ: {form.getFieldValue(['realizado', 'cnpj'])}</Flex>
                                            </Flex>
                                        </Card>
                                    }
                                </Flex>
                            </Flex>
                        </Col>

                    </Row>
                </Card>
                }

                <Card variant='borderless' type='inner' size='small' title={<Flex align='center' gap={5}>
                    <Avatar shape='square' src={CONTRATANTE} size={'small'} />
                    CONTRATANTE</Flex>}>
                    <Row gutter={8}>
                        <Col span={24}>
                            <Form.Item
                                name='ispj'
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}>
                                <Radio.Group
                                    optionType='button'
                                    buttonStyle='solid'>
                                    <Radio value={1}>Pessoa Jurídica - PJ</Radio>
                                    <Radio value={0}>Pessoa Física - PF</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={18}>
                            <Form.Item
                                label={<Flex gap={5} align='center'>{ispjObservavel === 1 ? "Razão Social" : "Nome"}</Flex>}
                                name={['contratante', 'razao']}
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}>
                                <Input maxLength={250} />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={6}>
                            <Form.Item
                                label={<Flex gap={5} align='center'>{ispjObservavel === 1 ? "CNPJ" : "CPF"}</Flex>}
                                name={['contratante', 'cnpj']}
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}>
                                <InputMask
                                    mask={ispjObservavel === 1 ? "99.999.999/9999-99" : "999.999.999-99"}
                                    placeholder={ispjObservavel === 1 ? "99.999.999/9999-99" : "999.999.999-99"}
                                >
                                    {(inputProps) => <Input {...inputProps} />}
                                </InputMask>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={9}>
                            <Form.Item
                                label={"Endereço do serviço"}
                                name={['contratante', 'endereco']}
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}>
                                <Input maxLength={250} />
                            </Form.Item>
                        </Col>





                        <Col xs={24} md={5}>
                            <Form.Item
                                label={"Bairro"}
                                name={['contratante', 'bairro']}
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}>
                                <Input maxLength={45} />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={4}>
                            <Form.Item
                                label={"Cidade"}
                                name={['contratante', 'cidade']}
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}>
                                <Input maxLength={50} />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={3}>
                            <Form.Item
                                label={"CEP"}
                                name={['contratante', 'cep']}
                                rules={[{ required: true, message: 'Obrigatório!' }]}>
                                <InputMask
                                    mask={"99999-999"}
                                    placeholder={"60000-000"}
                                >
                                    {(inputProps) => <Input {...inputProps} />}
                                </InputMask>
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={3}>
                            <Form.Item
                                label={"Estado"}
                                name={['contratante', 'estado']}
                                rules={[{ required: true, message: 'Obrigatório!' }]}>
                                <Input maxLength={45}/>
                            </Form.Item>
                        </Col>
                    </Row>
                </Card>

                <Card variant='borderless' type='inner' size='small' title={<Flex align='center' gap={5}>
                    <Avatar shape='square' src={INFORMACOES} size={'small'} />
                    OUTRAS INFORMAÇÕES</Flex>}>
                    <Row gutter={8}>
                        <Col xs={24} md={10}>
                            <Form.Item
                                label={"E-mail"}
                                name={'email'}
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}>
                                <Input maxLength={50} />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={4}>
                            <Form.Item
                                label={"Celular"}
                                name={'celular'}
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}>
                                <TelefoneBrasileiroInput
                                    temDDD
                                    separaDDD
                                    separaNono={false}
                                    className={'ant-input css-dev-only-do-not-override-1d8anct ant-input-outlined css-var-r1 ant-input-css-var'}
                                />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={10}>
                            <Form.Item
                                label={"Responsável Financeiro (boleto)"}
                                name={'respfinanceiro'}
                                rules={[{ required: true, message: 'Esse campo é obrigatório!' }]}>
                                <Select style={{ width: '100%' }}>
                                    <option value={0}><Flex gap={5}>{user?.nome}</Flex></option>
                                    {razaoObservable && <option value={1}><Flex gap={5}>{razaoObservable}</Flex></option>}
                                </Select>
                            </Form.Item>
                        </Col>


                    </Row>
                </Card>




            </Flex>

            <Flex gap={10} justify='flex-end' style={{ marginTop: 10, display: previa ? 'none' : 'flex' }}>
                {current === 0 && <Button onClick={() => {
                    setCurrent(0)
                    props.setOpen(false)
                    props.getArts()
                    setPrevia(false)
                }}> {"Cancelar"}</Button>}
                {current === 0 && <Button htmlType='submit' loading={loading} type='primary' >
                    Prévia </Button>}
            </Flex>



            <Flex vertical style={{ display: previa ? 'flex' : 'none' }}>
                <Flex justify='center'> <Tag color={'green-inverse'} style={{ fontSize: 15 }}>PRÉVIA DE ART</Tag> </Flex>
                <div id="meueditor" >
                    <div style={{ textAlign: 'center' }}>
                        <Flex vertical>
                            <Flex justify='center'>
                                <Image preview={false} alt='brazao' src={BRASAO} height={80} style={{ marginTop: 8 }} />
                            </Flex>
                            <Flex justify={'center'} vertical align='center' style={{ fontSize: 14, marginTop: 10 }}>
                                <Flex><b>SERVIÇO PÚBLICO FEDERAL</b></Flex>
                                <Flex><b>CONSELHO REGIONAL DE QUÍMICA DA 10ª REGIÃO</b></Flex>
                                <Flex>Rua Floriano Peixoto, 2020 Bairro José Bonifácio - CEP: 60025-131</Flex>
                                <Flex>Fortaleza-Ceará Fones: 85 3226-4958 / 3253-1607</Flex>
                                <Flex gap={10} align='center'>
                                    <Flex>E-mail</Flex>
                                    <Flex style={{ color: 'blue' }}>crqx@crqx.org.br / rt@crqx.org.br</Flex>
                                    <Flex style={{ marginLeft: 10 }}>site:</Flex>
                                    <Flex style={{ color: 'blue' }}>www.crqx.org.br</Flex>
                                </Flex>
                                <Flex style={{ fontWeight: 'bold', marginTop: 20 }}>ANOTAÇÃO DE RESPONSABILIDADE TÉCNICA - ART</Flex>
                                <Flex style={{ fontWeight: 'bold', marginBottom: 5 }}>Nº XXXXX/{dayjs().format("YYYY")}</Flex>
                            </Flex>
                        </Flex>


                        <div style={{ width: '21cm', justifyContent: 'center', justifySelf: 'center' }}>
                            <div style={{ marginTop: '30px', textAlign: 'justify' }}>
                                &nbsp;&nbsp;&nbsp;Conforme R.N. Nº. 47, de 24.08.1978, do Conselho Federal de Química, consta no sistema de registro eletrônico deste Conselho,
                                que {(user?.sexo === 'F' ? `a` : `o`)}&nbsp;{user?.sexo === 'F' ? user?.nomef : user?.categoria}
                                &nbsp;<b>{user?.nome}</b>,&nbsp;{(user?.posgrad ? " com ".concat(user?.posgrad, ", ") : '')}

                                {(user?.sexo === 'F' ? `registrada` : `registrado`)} neste Conselho Regional de Química da 10ª. Região sob o número&nbsp;{user?.crq}, de acordo com a Lei Nº. 2.800, de 18.06.1956, comunicou a este Conselho Regional de Química, em obediência ao Decreto-Lei 5452, de 01.05.1943, da CLT a
                                seguinte atividade:
                            </div>

                            <div style={{ textAlign: 'justify' }}>
                                <ul><li>
                                    <b>{form.getFieldValue('descricao')}</b>
                                </li> </ul>

                            </div>

                            <div style={{ textAlign: 'justify' }}>
                                &nbsp;&nbsp;&nbsp;Para {ispjObservavel === 1 ? "a empresa" : ""} <b>{form.getFieldValue(['contratante', 'razao'])}</b>,
                                {ispjObservavel === 1 ? " inscrita no CNPJ sob " : " pessoa física inscrita no CPF "}
                                Nº. {form.getFieldValue(['contratante', 'cnpj'])?.replaceAll('_', '')},
                                com endereço do serviço: {form.getFieldValue(['contratante', 'endereco'])}, Bairro: {form.getFieldValue(['contratante', 'bairro'])},
                                CEP: {form.getFieldValue(['contratante', 'cep'])?.replaceAll('_', "")}, no município de {form.getFieldValue(['contratante', 'cidade'])}, estado do Ceará,
                                {consultaViaPJ(form.getFieldValue('viapj'))} exercida conforme atribuições profissionais constantes da RN Nº. 36, de 25.04.1974, do Conselho Federal de Química.
                            </div>

                            <div style={{ textAlign: 'justify', marginTop: 5 }}>
                                &nbsp;&nbsp;&nbsp;É o que consta, a presente ART não contém emendas,
                                rasuras e entrelinhas, em {new Intl.DateTimeFormat('pt-BR', { dateStyle: 'full' }).format(new Date())}
                                .
                            </div>
                            <div style={{ textAlign: 'left' }}><b>VÁLIDO ATÉ {dayjs().add(6, 'M').format('DD/MM/YYYY')}.</b></div>


                        </div>
                    </div>
                </div>

                <Alert showIcon={true} banner={true} style={{ fontSize: '0.9em', marginTop: 15 }} type='info'
                    description={<Flex vertical style={{ fontStyle: 'italic' }}>
                        <Flex>
                            {idartscodeObservable === 0 ? <span>O <b>Boleto/PIX</b> para pagamento será disponibilizado após análise da solicitação.</span> : ""}
                        </Flex>
                        <Flex>
                            {idartscodeObservable === 0 ? <span>A <b>ART</b> estará disponível após identificação do pagamento da respectiva taxa, bem como a <b>análise e aprovação</b> das informações aqui prestadas.</span>
                                : "A ART estará disponível após identificação do pagamento da respectiva taxa."}
                        </Flex>

                    </Flex>}>
                </Alert>


                <Divider />
                <Flex justify='center' gap={25}>
                    <Button icon={<LeftOutlined />} onClick={() => setPrevia(false)}>Voltar</Button>
                    {current === 0 && <Button htmlType='submit' style={{ width: 100 }} loading={loading} type='primary' >
                        Enviar </Button>}
                </Flex>
            </Flex>



        </Form>



        <Modal
            open={open2}
            title={null}
            footer={null}
            closable={false}
            width={600}>

            <Result
                status={'success'}
                title={"Solicitação enviada com sucesso!"}
                subTitle={<Flex vertical>
                    <Flex>O Boleto e/ou chave PIX para pagamento será disponibilizado assim que a solicitação for analisada.
                        Quando a ART for emitida você poderá efetuar o download aqui no MeuCRQCE.</Flex>

                </Flex>}
                extra={[
                    <Button onClick={() => {
                        setOpen2(false)
                        props.setOpen(false)
                        props.getArts()

                    }}>Fechar</Button>
                ]}>

            </Result>



        </Modal>
    </Flex>


}